/**
 * Country-specific energy defaults for pilot communities.
 *
 * Sources:
 *   PV yield: PVGIS (2024), typical fixed-tilt residential/community systems
 *   CO2 factor: EEA/Ember (2024 grid carbon intensity)
 *   Wind CF: IEA Wind TCP, national averages for onshore wind
 *   Tariffs: Eurostat H1/H2 2024, representative residential rates
 *
 * Usage: import { getCountryDefaults } from '../data/countryDefaults'
 *        const cd = getCountryDefaults('Italy')
 *        // cd.pvYieldKwhPerKwp === 1300
 */

const COUNTRY_DEFAULTS = {
  'Czech Republic': {
    pvYieldKwhPerKwp: 1050,
    co2FactorKgPerKwh: 0.40,
    windCapacityFactor: 0.22,
    tariffImportEur: 0.22,
    tariffExportEur: 0.08,
  },
  Germany: {
    pvYieldKwhPerKwp: 950,
    co2FactorKgPerKwh: 0.35,
    windCapacityFactor: 0.25,
    tariffImportEur: 0.30,
    tariffExportEur: 0.08,
  },
  Italy: {
    pvYieldKwhPerKwp: 1300,
    co2FactorKgPerKwh: 0.23,
    windCapacityFactor: 0.22,
    tariffImportEur: 0.25,
    tariffExportEur: 0.06,
  },
  Greece: {
    pvYieldKwhPerKwp: 1400,
    co2FactorKgPerKwh: 0.45,
    windCapacityFactor: 0.28,
    tariffImportEur: 0.18,
    tariffExportEur: 0.07,
  },
  France: {
    pvYieldKwhPerKwp: 1150,
    co2FactorKgPerKwh: 0.05,
    windCapacityFactor: 0.24,
    tariffImportEur: 0.20,
    tariffExportEur: 0.06,
  },
}

const FALLBACK = {
  pvYieldKwhPerKwp: 1000,
  co2FactorKgPerKwh: 0.40,
  windCapacityFactor: 0.25,
  tariffImportEur: 0.15,
  tariffExportEur: 0.05,
}

export function getCountryDefaults(country) {
  return COUNTRY_DEFAULTS[country] || FALLBACK
}

export default COUNTRY_DEFAULTS
